import {
  Control,
  Controller,
  FieldErrors,
  UseFormGetValues,
  UseFormSetValue,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { AllEnums, EnumListKey } from '~/data/enums';
import { useSxStyles } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/ScheduleEmploymentDetail/components/FormComponent/useStyles';
import { useFilterActiveEnumsByFormSelections } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/data/useFilterActiveEnumsByFormSelections';
import { Form } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';
import { LegacyAutocompleteField } from '~/legacy-components/LegacyForms';

type Props = {
  control: Control<Form>;
  errors: FieldErrors<Form>;
  getValues: UseFormGetValues<Form>;
  allEnums: AllEnums;
  index: number;
  setValue: UseFormSetValue<Form>;
  disabled?: boolean;
};

export const EmploymentStatusComponent = ({
  control,
  allEnums,
  errors,
  index,
  getValues,
  setValue,
  disabled,
}: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const requiredText = t('fieldIsRequired');

  const { filterActiveEnumsByFormSelections } =
    useFilterActiveEnumsByFormSelections({
      control,
      index,
      getValues,
    });

  const filteredOptions = filterActiveEnumsByFormSelections(
    allEnums[EnumListKey.EMPLOYMENT_STATUS],
  );

  return (
    <Controller
      control={control}
      name={`schedule.${index}.employmentDetails.fEmplDetailStatus`}
      rules={{ required: requiredText }}
      render={({ field: { onChange, value } }) => (
        <LegacyAutocompleteField
          options={filteredOptions}
          getOptionLabel={(o) => o?.name || ''}
          isOptionEqualToValue={(o, v) => o?.code === v?.code}
          onChange={(_, value) => onChange(value?.code || '')}
          value={filteredOptions.find((o) => o?.code === value) || null}
          sx={sxStyles.selectStyle}
          fieldError={
            errors.schedule?.[index]?.employmentDetails?.fEmplDetailStatus
          }
          required={true}
          label={t('laEmploymentStatus')}
          disabled={disabled}
        />
      )}
    />
  );
};
